import React, { useState } from "react";
import { useNavigate } from "react-router-dom";

import HeroSection from "./Home/MainLandingScreen";
import Background from "assets/Home/LandingPageBg.png";
import ManageRepairs from "./Home/ManageRepairs";
import SettingsIcon from "assets/Home/Settings.svg";
import SearchScanIcon from "assets/Home/SearchScan.svg";
import LinkIcon from "assets/Home/Link.svg";
import ServiceProfessionals from "./Home/ServiceProfessionals";
import LicenseInsurance from "assets/Home/LicenseInsurance.svg";
import Location from "assets/Home/Location.svg";
import Review from "assets/Home/Review.svg";
import Award from "assets/Home/Award.svg";
import HowItWorks from "./Home/PropertyWorlFlow";
import TransparentPricing from "./Home/TransparentPricing";
import HandsOnToFree from "./Home/HandsOnToFree";
import Clock from "assets/Home/Clock.svg";
import BellIcon from "assets/Home/BellIcon.svg";
import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import PhoneIcon from "assets/Home/Phone.svg";
import HelpIcon from "assets/Home/HelpCircle.svg";
import CalendarIcon from "assets/Home/Calendar.svg";
import EyeIcon from "assets/Home/Eyeoff.svg";
import CheckCircle from "assets/Home/CheckCircle.svg";
import Globe from "assets/Home/Globe.svg";
import FaceFrown from "assets/Home/FaceFrown.svg";
import ClipdownCheck from "assets/Home/ClipdownCheck.svg";
import Unlock from "assets/Home/Unlock.svg";
import HomeLine from "assets/Home/HomeLine.svg";
import BarChart from "assets/Home/BarChart.svg";
import BankNote from "assets/Home/BankNote.svg";
import Lock from "assets/Home/Lock.svg";
import PhoneHandUp from "assets/Home/PhoneHandUp.svg";
import FrequentlyAskedQuestions from "./Home/FrequentlyAskedQuestions";
import StayUpdated from "./Home/StayUpdated";
import NoCostModel from "components/Home/NoCostModel.jsx";
import LandlordPropertiesCTA from "./Home/LandlordPropertiesCTA";

const LandlordLandingPage = () => {
  const navigate = useNavigate();
  const GetStartedCTA = (props) => (
    <div className="lg:max-w-[1440px] w-full mx-auto">
      <div className="w-full md:px-12 px-5 mt-2 mb-6">
        <button
          onClick={() => navigate("/signup?account_type=LANDLORD")}
          style={props.style}
          className="bg-[#47C272] hover:bg-opacity-90 text-white font-medium text-[16px] py-3 px-6 rounded-[8px] transition-all"
        >
          Get Started for Free
        </button>
      </div>
    </div>
  );
  const [selectedTab, setSelectedTab] = useState(0);
  const cards = [
    {
      icon: SettingsIcon,
      title: "We handle maintenance for you",
      description:
        "Tenants submit requests through our system, and we take care of assigning the right vendor. No calls, no back-and-forth, no stress.",
    },
    {
      icon: SearchScanIcon,
      title: "You can see what's going on",
      description:
        "Track the status of every job in your dashboard. Get updates, photos, and invoices without having to follow up with tenants or vendors.",
    },
    {
      icon: LinkIcon,
      title: "Everything in one place",
      description:
        "All requests, jobs, and payments are managed through one simple platform. No disorganized texts, emails, or paperwork.",
    },
  ];
  const cardsProfessionals = [
    {
      icon: LicenseInsurance,
      title: "Licensed & Insured",
    },
    {
      icon: Location,
      title: "Locally Vetted",
    },
    {
      icon: Review,
      title: "Highly Rated",
    },
    {
      icon: Award,
      title: "Satisfaction Guarantee",
    },
  ];
  const steps = [
    {
      number: "01",
      basis: "59%",
      title: "Tenant submits repair request",
      description:
        "Your tenant reports any issue through Properteasy by providing details, images, and scheduling availability. This gives us everything we need to get started. No landlord action is required.",
    },
    {
      number: "02",
      basis: "41%",
      title: "If you feel the work needs to be done, approve it!",
      description:
        "You’re instantly notified of the request and can review the details and estimate at your leisure. If you choose to move forward, simply approve it with one click.",
    },
    {
      number: "03",
      basis: "42%",
      title:
        "We assess the issue and broadcast the job to the most suitable vendors",
      description:
        "Properteasy reviews the request, identifies the issue, and assigns it to the most qualified, local professionals.",
    },
    {
      number: "04",
      basis: "58%",
      title:
        "Vendor accepts the job at a time that works for your tenants",
      description:
        "A qualified vendor reviews the details and accepts the job based upon your tenants availability. They can alternatively provide access instructions so the work can get done, even if nobody’s home.",
    },
    {
      number: "05",
      basis: "50%",
      title: "You're kept in the loop every step of the way",
      description:
        "You receive real-time updates throughout the process so you always know what’s happening with your property, and when. No more wondering or chasing down job status from afar.",
    },
    {
      number: "06",
      basis: "50%",
      title: "Pay when the work is completed",
      description:
        "Once the maintenance request is resolved, you’ll receive a final invoice. All payments are made securely and conveniently through Properteasy.",
    },
  ];
  const renderSection = {
    0: {
      leftSection: [
        {
          icon: PhoneIcon,
          text: "3 am tenant calls",
        },
        {
          icon: HelpIcon,
          text: "Not knowing who to call and if they’ll even be available",
        },
        {
          icon: CalendarIcon,
          text: "3-way scheduling nightmares",
        },
        {
          icon: EyeIcon,
          text: "No visibility into job progress",
        },
      ],
      rightSection: [
        {
          icon: CheckCircle,
          text: "No more texts or calls. We handle the requests",
        },
        {
          icon: Globe,
          text: "An expansive vendor network in every service category",
        },
        {
          icon: Clock,
          text: "Intuitive scheduling all in one place for everyone",
        },
        {
          icon: BellIcon,
          text: "Real-time notifications and updates from start to finish",
        },
      ],
    },
    1: {
      leftSection: [
        {
          icon: BankNote,
          text: "Fixed management fees even when nothing breaks",
        },
        {
          icon: Lock,
          text: "Locked into contracts",
        },
        {
          icon: PhoneHandUp,
          text: "Little communication and even less transparency",
        },
        {
          icon: FaceFrown,
          text: "Tiered client treatment",
        },
      ],
      rightSection: [
        {
          icon: ClipdownCheck,
          text: "Maintenance when you need it, not when you don’t",
        },
        {
          icon: Unlock,
          text: "No contracts. No lock-ins",
        },
        {
          icon: HomeLine,
          text: "Full transparency and communication every step of the way, all in one place",
        },
        {
          icon: BarChart,
          text: "Consistent service, whether you own 1 or 100 units",
        },
      ],
    },
  };

  return (
    <div
      style={{ marginTop: "96px" }}
      className="flex flex-col justify-center w-full items-center   "
    >
      <HeroSection
        background={Background}
        title={
          <>
            One platform. One contact.
            <br />
            No contracts. No headaches.
          </>
        }
        description="No fee maintenance management so you can focus on profits, not problems"
        buttonText="Get Started as a Landlord"
        buttonLink="/signup?account_type=LANDLORD"
      />
      <ManageRepairs
        id="property-maintenance-landlord"
        classFlex="flex gap-8 md:flex-row flex-col  "
        chipTxt="Property Maintenance"
        iconStyle={{ opacity: 0.55 }}
        cards={cards}
        title="Everything You Need To Manage Repairs Without The Headaches"
        description="We handle repair requests from start to finish, including vendor dispatch and real-time progress updates. You stay in control without dealing with calls, scheduling, or follow ups."
      />
      <GetStartedCTA/>
      <ServiceProfessionals
        id="end-to-end-repair-management-landlord"
        cards={cardsProfessionals}
        iconStyle={{ opacity: 0.55 }}
        chipText="End-to-End Repair Management"
        title="Service Professionals You Can Trust"
        description="We get it, finding a trusted professional is hard. Properteasy
            removes the guesswork by vetting every service professional before
            they ever reach your door."
      >
        {" "}
        <div className="flex  gap-[10px]  text-[#242424] md:flex grid">
          <h2 className="text-[18px] md:text-[22px] bg-[#F6F7F9] w-full p-6 rounded-[20px]  ">
            Our rigorous evaluation process includes license and insurance
            verification, as well as client reference validation. Only those who
            demonstrate consistent excellence and reliability are given the
            opportunity to serve our landlords and their tenants.
          </h2>
          <h2 className="text-[18px] md:text-[22px] bg-[#F6F7F9] w-full p-6 rounded-[20px]  ">
            Our screening process is hands on, ensuring only the most
            dependable, skilled, and trustworthy vendors make the cut. Our
            service providers are established local tradesmen with proven track
            records, the professionals you wish you had from the start. With
            Properteasy, now you do.
          </h2>
        </div>
      </ServiceProfessionals>
      <GetStartedCTA />
      <NoCostModel buttonLink="/signup?account_type=LANDLORD" />

      <HowItWorks
        id="how-properteasy-works-landlord"
        chipText="Trusted by 20,000+ members"
        title="Here's How We Make Repairs Easy"
        steps={steps}
      />
      <TransparentPricing id="pricing-landlord" />
      <GetStartedCTA />
      <HandsOnToFree buttonLink="/signup?account_type=LANDLORD"
        id="what-makes-properteasy-different-landlord"
        title={
          selectedTab === 0
            ? "From Hands On to Hands Free"
            : "Only Pay for the Services You Need"
        }
        subTitleone={
          selectedTab === 0
            ? "Self Management"
            : "Traditional Property Management"
        }
        subTitleTwo="With Properteasy"
        leftSection={renderSection[selectedTab].leftSection}
        rightSection={renderSection[selectedTab].rightSection}
      >
        {" "}
        <h1
          className={`  flex-1 font-[400] w-full pb-6  text-[#242424] text-[24px] md:text-[48px] leading-tight sm:leading-tight md:leading-tight lg:leading-[69px] tracking-[0]`}
        >
          Whether you self manage or work with a traditional property manager,
          see how Properteasy stacks up against your current solution.
        </h1>
        <div className="flex w-full  mx-auto bg-[#F3F3F3] max-w-[524px] rounded-[12px] border border-[#ECECEC] overflow-hidden p-1 ">
          {["Self Management", "Traditional Property Management"].map(
            (tab, idx) => (
              <button
                key={tab}
                onClick={() => setSelectedTab(idx)}
                className={`py-2 text-center w-full text-nowrap  md:text-[18px] text-[12px] transition-all duration-200 focus:outline-none ${
                  selectedTab === idx
                    ? "bg-white text-[#242424] font-bold shadow"
                    : "bg-transparent text-[#595959] font-semibold"
                }`}
              >
                {tab}
              </button>
            )
          )}
        </div>
      </HandsOnToFree>
      <LandlordPropertiesCTA id="contact-landlord-properties" buttonLink="/signup?account_type=LANDLORD" />
      <FrequentlyAskedQuestions id="faqs-landlord" />
      <StayUpdated id="stay-updated-landlord" />
    </div>
  );
};

export default LandlordLandingPage;
